<form [formGroup]="otpForm" (ngSubmit)="sendOtp()" class="py-6 px-4 md:px-12 max-w-lg mx-auto">
  <div class="text-center mb-6">
    <h3 class="text-xl md:text-2xl font-bold text-gray-800">Login with OTP</h3>
    <p class="text-sm text-gray-500 mt-1">Select your user role and enter your mobile number</p>
  </div>

  <!-- User Type Selection -->
  <div class="mb-5 relative z-30">
    <app-custom-select label="Select User Type" [options]="UserType" formControlName="user_type"
      selectId="otpUserType">
    </app-custom-select>
    <div *ngIf="f['user_type'].touched && f['user_type'].invalid" class="text-red-500 text-xs mt-1">
      Please select a user type
    </div>
  </div>

  <!-- Mobile Number Input -->
  <div class="relative mb-6 z-10">
    <input formControlName="mobilenumber" type="text" id="mobilenum"
      class="block px-3.5 pb-3 pt-3 w-full text-base text-gray-800 font-medium bg-white rounded-lg border border-gray-300 focus:outline-none focus:border-c19725 focus:ring-1 focus:ring-c19725 peer transition-all"
      placeholder=" " />
    <label for="mobilenum"
      class="absolute text-sm text-gray-500 duration-300 transform -translate-y-4 scale-75 top-2 z-10 bg-white px-2 peer-focus:text-c19725 peer-placeholder-shown:scale-100 peer-placeholder-shown:top-1/2 peer-placeholder-shown:-translate-y-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 start-2">
      Mobile Number
    </label>
    <div *ngIf="f['mobilenumber'].touched && f['mobilenumber'].invalid" class="text-red-500 text-xs mt-1">
      Mobile number must be 10 digits
    </div>
  </div>

  <!-- Button -->
  <div class="flex items-center justify-center mt-6">
    <button type="submit" [disabled]="isLoading"
      class="flex items-center justify-center cursor-pointer w-full py-3.5 text-lg font-bold text-white bg-c19725 border-2 border-c19725 hover:bg-[#d4a832] hover:shadow-md transition-all rounded-lg disabled:opacity-70 disabled:cursor-not-allowed">
      <ng-container *ngIf="!isLoading; else loadingTemplate">
        Get OTP
      </ng-container>
      <ng-template #loadingTemplate>
        <i class="fas fa-spinner fa-spin mr-2"></i> Sending...
      </ng-template>
    </button>
  </div>
</form>
